import { NEXT_PUBLIC_API_URL } from '@/configs/env'
import axios from 'axios'
import queryString from 'query-string'

const axiosService = axios.create({
  baseURL: `${NEXT_PUBLIC_API_URL}`,
  headers: {
    'content-type': 'application/json',
  },
  paramsSerializer: (params: any) => queryString.stringify({ ...params }),
  proxy: false,
  // adapter: cache.adapter,
})

export default axiosService
